import React from 'react';

const PostActions = ({ 
  post, 
  onLike, 
  isLiking, 
  activeCommentPost, 
  setActiveCommentPost 
}) => {
  return (
    <div className="flex items-center gap-6 border-t border-gray-100 pt-4">
      <button
        onClick={() => onLike(post.postId || post._id || post.id)}
        disabled={isLiking}
        className={`flex items-center gap-2 transition-colors disabled:opacity-50 ${
          post.isLiked
            ? "text-red-500"
            : "text-gray-600 hover:text-red-500"
        }`}
      >
        {isLiking ? (
          <div className="animate-spin rounded-full h-6 w-6 border-2 border-red-500 border-t-transparent"></div>
        ) : (
          <svg
            className="w-6 h-6"
            fill={post.isLiked ? "currentColor" : "none"}
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>
        )}
        <span className="font-medium">{post.likesCount || 0} likes</span>
      </button>

      <button
        onClick={() => setActiveCommentPost(
          activeCommentPost === (post.postId || post._id || post.id) ? null : (post.postId || post._id || post.id)
        )}
        className="flex items-center gap-2 text-gray-600 hover:text-blue-500 transition-colors"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
        <span className="font-medium">{post.commentsCount || 0} comments</span>
      </button>
    </div>
  );
};

export default PostActions; 